import { BaseResource } from './base';
import { Message, GetMessagesParams } from '../models/messages';
import { RequestOptions } from '../types';

interface MessagesResponse {
  data: Message[];
}

export class MessagesResource extends BaseResource {
  private basePath = 'messages';

  async getMessages(params?: GetMessagesParams, options?: RequestOptions): Promise<Message[]> {
    const response = await this.client.get<MessagesResponse>(this.basePath, params, options);
    return response.data;
  }

  async getMessage(id: string, options?: RequestOptions): Promise<Message> {
    return this.client.get<Message>(`${this.basePath}/${id}`, undefined, options);
  }

  async retryMessage(id: string, options?: RequestOptions): Promise<Message> {
    return this.client.post<Message>(`${this.basePath}/${id}/retry`, undefined, options);
  }

  async cancelMessage(id: string, options?: RequestOptions): Promise<Message> {
    return this.client.post<Message>(`${this.basePath}/${id}/cancel`, undefined, options);
  }
}
